import { render } from "./Experts.vue?vue&type=template&id=fa27ff2c&scoped=true"
import script from "./Experts.vue?vue&type=script&lang=js"
export * from "./Experts.vue?vue&type=script&lang=js"

import "./Experts.vue?vue&type=style&index=0&id=fa27ff2c&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa27ff2c"]])

export default __exports__